import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Back from "../components/button/back";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    username: "",
    password: "",
    role: "",
    NISN: "",
    NIPD: "",
    NIP: "",
    statusPPH: "",
    jabatan: "",
    name: "",
    kelamin: "",
    Agama: "",
    TL: "",
    TGL: "",
    SekolahAsal: "",
    TGLditerima: "",
    Alamat: "",
    anakke: "",
    ayah: "",
    ibu: "",
    wali: "",
    Payah: "",
    Pibu: "",
    Pwali: "",
    kelas: "",
    rombel: "",
    mapel: "",
    image: null, // image object { fileId, filename, mimetype }
  });
  const [previewUrl, setPreviewUrl] = useState(null);

  const [file, setFile] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}api/auth/users/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );
        const userData = res.data;
        const formattedTGL = userData.TGL
          ? new Date(userData.TGL).toISOString().split("T")[0]
          : "";

        setUser({ ...userData, TGL: formattedTGL, password: "" });
      } catch (error) {
        toast.error("Gagal memuat data user");
      }
    };

    fetchUser();
  }, [id]);

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setPreviewUrl(URL.createObjectURL(selectedFile));
    }
  };

  const handleImageUpload = async () => {
    if (!file) return user.image; // Tidak ganti gambar

    const formData = new FormData();
    formData.append("image", file);

    // Kirim oldFileId jika ada
    if (user.image?.fileId) {
      formData.append("oldFileId", user.image.fileId);
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}api/auth/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      return res.data.image; // { filename, fileId, mimetype }
    } catch (err) {
      toast.error("Gagal upload gambar");
      return user.image;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedImage = await handleImageUpload();

    const updatedUser = {
      ...user,
      image: updatedImage,
      password: user.password || undefined, // jika tidak diisi, tidak diubah
    };

    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}api/auth/users/${id}`,
        updatedUser,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      toast.success("User berhasil diperbarui");
      setTimeout(() => {
        navigate("/admin");
      }, 1000);
    } catch (err) {
      console.error("Error updating user:", err);
      toast.error("Gagal memperbarui user");
    }
  };

  return (
    <div className="grid justify-center min-h-screen bg-blue-100">
      <ToastContainer />
      <div className="px-5 py-5">
        <h1 className="text-3xl font-bold text-center py-4">Edit User</h1>

        <div className="bg-white rounded-lg shadow-lg p-6 max-w-2xl">
          <form onSubmit={handleSubmit} className="grid gap-y-3">
            <Input
              label="Username"
              name="username"
              value={user.username}
              onChange={handleChange}
            />
            <Input
              label="Password"
              name="password"
              value={user.password}
              onChange={handleChange}
              type="password"
              placeholder="Kosongkan jika tidak diubah"
            />

            <Select
              label="Role"
              name="role"
              value={user.role}
              onChange={handleChange}
              options={["admin", "guru", "siswa"]}
            />

            {user.role === "siswa" && (
              <>
                <Input
                  label="NISN"
                  name="NISN"
                  value={user.NISN}
                  onChange={handleChange}
                />
                <Input
                  label="NIPD"
                  name="NIPD"
                  value={user.NIPD}
                  onChange={handleChange}
                />
                <Select
                  label="Kelas"
                  name="kelas"
                  value={user.kelas}
                  onChange={handleChange}
                  options={["1", "2", "3", "4", "5", "6", "lulus"]}
                />
                <Select
                  label="Rombel"
                  name="rombel"
                  value={user.rombel}
                  onChange={handleChange}
                  options={["A", "B", "C", "D"]}
                />
                <Input
                  label="Sekolah Asal"
                  name="SekolahAsal"
                  value={user.SekolahAsal}
                  onChange={handleChange}
                />
                <Input
                  label="Tanggal Diterima di sekolah"
                  name="TGLditerima"
                  value={user.TGL}
                  onChange={handleChange}
                  type="date"
                />{" "}
                <Input
                  label="anak ke"
                  name="anakke"
                  value={user.anakke}
                  onChange={handleChange}
                />
                <Input
                  label="ayah"
                  name="ayah"
                  value={user.ayah}
                  onChange={handleChange}
                />
                <Select
                  label="Pekerjaan Ayah"
                  name="Payah"
                  value={user.Payah}
                  onChange={handleChange}
                  options={[
                    "PNS/TNI/Polri",
                    "Swasta",
                    "Wiraswasta/wirausaha",
                    "Lainnya",
                  ]}
                />
                <Input
                  label="ibu"
                  name="ibu"
                  value={user.ibu}
                  onChange={handleChange}
                />
                <Select
                  label="Pekerjaan Ibu"
                  name="Pibu"
                  value={user.Pibu}
                  onChange={handleChange}
                  options={[
                    "PNS/TNI/Polri",
                    "Swasta",
                    "Wiraswasta/wirausaha",
                    "Lainnya",
                  ]}
                />
                <Input
                  label="Wali"
                  name="wali"
                  value={user.wali}
                  onChange={handleChange}
                />
                <Select
                  label="Pekerjaan Wali"
                  name="Pwali"
                  value={user.Pwali}
                  onChange={handleChange}
                  options={[
                    "PNS/TNI/Polri",
                    "Swasta",
                    "Wiraswasta/wirausaha",
                    "Lainnya",
                  ]}
                />
              </>
            )}

            {user.role === "guru" && (
              <>
                <Input
                  label="NIP"
                  name="NIP"
                  value={user.NIP}
                  onChange={handleChange}
                />
                <Select
                  label="Status"
                  name="statusPPH"
                  value={user.statusPPH}
                  onChange={handleChange}
                  options={["PNS", "PPPK", "Honorer"]}
                />
                <Select
                  label="Jabatan"
                  name="jabatan"
                  value={user.jabatan}
                  onChange={handleChange}
                  options={["Kepala Sekolah", "Guru Mapel", "Guru Kelas"]}
                />

                {user.jabatan === "Guru Kelas" && (
                  <>
                    <Select
                      label="Kelas"
                      name="kelas"
                      value={user.kelas}
                      onChange={handleChange}
                      options={["1", "2", "3", "4", "5", "6"]}
                    />
                    <Select
                      label="Rombel"
                      name="rombel"
                      value={user.rombel}
                      onChange={handleChange}
                      options={["A", "B", "C", "D"]}
                    />
                  </>
                )}

                {user.jabatan === "Guru Mapel" && (
                  <Select
                    label="Mapel"
                    name="mapel"
                    value={user.mapel}
                    onChange={handleChange}
                    options={[
                      "IPA",
                      "IPS",
                      "MTK",
                      "BIndo",
                      "BIng",
                      "PAI",
                      "PKN",
                      "IPAS",
                      "PJOK",
                      "MULOK",
                      "Senibudaya",
                    ]}
                  />
                )}
              </>
            )}

            <Input
              label="Nama"
              name="name"
              value={user.name}
              onChange={handleChange}
            />
            <Select
              label="Kelamin"
              name="kelamin"
              value={user.kelamin}
              onChange={handleChange}
              options={["Laki-laki", "Perempuan"]}
            />
            <Select
              label="Agama"
              name="Agama"
              value={user.Agama}
              onChange={handleChange}
              options={[
                "Islam",
                "Kristen Protestan",
                "Kristen Katolik",
                "Hindu",
                "Buddha",
                "Konghucu",
              ]}
            />
            <Input
              label="Tempat Lahir"
              name="TL"
              value={user.TL}
              onChange={handleChange}
            />
            <Input
              label="Tanggal Lahir"
              name="TGL"
              value={user.TGL}
              onChange={handleChange}
              type="date"
            />
            <Input
              label="Alamat"
              name="Alamat"
              value={user.Alamat}
              onChange={handleChange}
            />

            <div>
              <label className="font-bold">Gambar:</label>
              <input type="file" onChange={handleFileChange} className="mt-1" />

              {/* Jika pengguna memilih gambar baru, tampilkan preview-nya */}
              {previewUrl ? (
                <div className="mt-2">
                  <p className="text-sm text-gray-500">Preview Gambar Baru:</p>
                  <img
                    src={previewUrl}
                    alt="Preview"
                    className="w-32 h-32 object-cover rounded border"
                  />
                </div>
              ) : user.image?.filename ? (
                // Jika belum memilih gambar baru, tampilkan gambar lama dari GridFS
                <div className="mt-2">
                  <p className="text-sm text-gray-500">Gambar Saat Ini:</p>
                  <img
                    src={`${process.env.REACT_APP_API_URL}api/auth/users/image/${user.image.filename}`}
                    alt="User"
                    className="w-32 h-32 object-cover rounded border"
                  />
                </div>
              ) : (
                // Jika belum ada gambar sama sekali
                <p className="text-sm text-gray-400 mt-1">Belum ada gambar</p>
              )}
            </div>

            <button
              type="submit"
              className="bg-blue-500 text-white py-2 px-4 rounded mt-4 hover:bg-blue-600"
            >
              Update User
            </button>
          </form>
        </div>

        <div className="flex justify-center pt-6">
          <Link to="/admin">
            <Back />
          </Link>
        </div>
      </div>
    </div>
  );
};

// 🔹 Reusable Input component
const Input = ({ label, ...props }) => (
  <div>
    <label className="font-bold">{label}:</label>
    <input
      {...props}
      className="w-full border border-gray-300 rounded-md p-2 mt-1"
    />
  </div>
);

// 🔹 Reusable Select component
const Select = ({ label, options, ...props }) => (
  <div>
    <label className="font-bold">{label}:</label>
    <select
      {...props}
      className="w-full border border-gray-300 rounded-md p-2 mt-1"
    >
      <option value="">Pilih {label}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  </div>
);

export default EditUser;
